module.exports = __webpack_public_path__ + "img/FR16278.482ca6ff.png";